export const brandInfo = {
  name: '98堂',
  fullName: '98堂',
  foundedYear: '2018',
  mission: '为用户提供最稳定、最安全的平台访问体验',
  vision: '成为最值得信赖的平台入口导航服务商',
  description: '98堂入口导航网站成立于2018年，始终致力于为用户提供最新、最可靠的98堂平台访问入口。经过多年发展，我们已累计服务超过500万用户，凭借稳定可靠的入口服务和专业的用户支持赢得了广泛好评。',
  story: '98堂入口导航网站的创立源于一个简单的理念：让每一位用户都能安全、快速地访问98堂平台。自2018年成立以来，我们始终坚守初心，不断优化入口线路、提升服务质量。从最初的单一入口到如今覆盖全球的多线路智能调度，我们与用户共同成长，见证了平台的蓬勃发展。\n\n我们的团队由经验丰富的网络安全专家和用户体验设计师组成，全天候监控入口状态，确保用户随时随地都能顺畅访问。我们深知，每一次成功登录背后，都是用户对我们的信任，这份信任是我们不断前进的动力。',
  values: [
    { title: '安全第一', description: '始终将用户数据安全和访问安全放在首位', icon: 'ri-shield-check-line' },
    { title: '用户至上', description: '以用户需求为导向，持续优化服务体验', icon: 'ri-heart-line' },
    { title: '技术创新', description: '不断引入新技术，提升入口的稳定性和速度', icon: 'ri-lightbulb-line' },
    { title: '诚信经营', description: '坚持透明、真实的信息发布，拒绝虚假宣传', icon: 'ri-hand-heart-line' },
  ],
};

export const testimonials = [
  {
    id: 1,
    name: '张先生',
    role: '资深用户 · 使用5年',
    content: '从2019年开始使用至今，98堂入口导航一直是我访问的首选。地址更新及时，遇到问题客服响应也很快，非常靠谱！',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: 2,
    name: '李女士',
    role: '活跃用户 · 使用3年',
    content: '之前经常找不到可用地址很头疼，自从收藏了这个导航页，再也没有迷路过。强烈推荐给所有98堂用户！',
    rating: 5,
    date: '2026-07-15',
  },
  {
    id: 3,
    name: '王先生',
    role: '企业用户 · 使用4年',
    content: '作为企业用户，访问稳定性对我们至关重要。98堂入口导航的多线路调度机制非常好，几乎从未断过。',
    rating: 5,
    date: '2026-07-10',
  },
  {
    id: 4,
    name: '赵女士',
    role: '新用户 · 使用6个月',
    content: '朋友推荐的这个导航站，界面简洁清晰，新手也能轻松上手。使用指南写得特别详细，小白福音！',
    rating: 5,
    date: '2026-07-05',
  },
  {
    id: 5,
    name: '陈先生',
    role: '技术用户 · 使用2年',
    content: '安全性方面做得很好，每次都会先验证地址有效性再发布。而且安全公告更新很及时，值得信赖。',
    rating: 5,
    date: '2026-06-28',
  },
  {
    id: 6,
    name: '刘女士',
    role: '长期用户 · 使用6年',
    content: '六年老用户了，见证了平台的成长。现在的入口速度和稳定性比早年提升太多了，给团队点赞！',
    rating: 5,
    date: '2026-06-20',
  },
];

export const achievements = [
  { value: '500万+', label: '累计服务用户' },
  { value: '8年', label: '稳定运营' },
  { value: '99.9%', label: '服务可用率' },
  { value: '50万+', label: '日均访问' },
];